// @flow

import { observer } from "mobx-react";
import React from "react";

import MediaRecorderStore from "app/stores/MediaRecorderStore";
import MediaRecorder from "app/components/MediaRecorder/MediaRecorder";

@observer
export default class MediaRecorderContainer extends React.Component<*> {
    render() {
        if (!MediaRecorderStore.isRecorderOpened) {
            return null;
        }

        return <MediaRecorder />;
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/MediaRecorderContainer.js